import { Box, Container, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { APP_NAME } from '@/config/app.config';
import { useThemeStore } from '@/stores/use-theme-store';

export function Footer() {
    const { t } = useTranslation();
    const { mode } = useThemeStore();

    return (
        <Box
            component="footer"
            sx={{
                py: 4,
                bgcolor: mode === 'dark' ? '#0A0B1A' : '#1F2937',
                color: 'rgba(255,255,255,0.6)',
            }}
        >
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 2,
                    }}
                >
                    <Typography variant="body2">
                        &copy; {new Date().getFullYear()} {APP_NAME}. {t('common.allRightsReserved')}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 3 }}>
                        <Link href="#" color="inherit" underline="hover" variant="body2">
                            {t('common.privacy')}
                        </Link>
                        <Link href="#" color="inherit" underline="hover" variant="body2">
                            {t('common.terms')}
                        </Link>
                        <Link href="#" color="inherit" underline="hover" variant="body2">
                            {t('common.contact')}
                        </Link>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;
